import { DECREMENT_LOADER_COUNT, INCREMENT_LOADER_COUNT } from "../types";

const initialState = {
	loaderCount: 0,
};

export const appReducer = (state = initialState, action) => {
	switch (action.type) {
		case INCREMENT_LOADER_COUNT:
			return {
				...state,
				loaderCount: ++state.loaderCount,
			};
		case DECREMENT_LOADER_COUNT:
			return {
				...state,
				loaderCount: --state.loaderCount,
			};
		default:
			return state;
	}
};
